import $ from '../common/nano';
import FullScreenGallery from '../components/FullScreenGallery';

class GalleryPage {
	private fullScreenGallery: FullScreenGallery;

	constructor() {
		this.intiEvents();
	}

	intiEvents() {
		$('.imageGroup-img')
			.one('click', () => {
				this.fullScreenGallery = new FullScreenGallery();
			})
			.on('click', (ev) => {
				const clicked 	= $(ev.target),
					  index 	= parseInt(<string> clicked.data('imgIndex'));

				this.fullScreenGallery.showFullScreen();
				this.fullScreenGallery.getGalleryApi().slideTo(index, 0);
				ev.preventDefault();
			});
	}

}

new GalleryPage();